<app-shive-grid #gridWrapperComponent [grid]="grid">
  <kendo-grid
    kendoGridSelectBy="id"
    scrollable="none"
    size="medium"
    [data]="gridData"
    [pageSize]="20"
    [selectable]="{ enabled: true, checkboxOnly: true }"
    [columnMenu]="{ filter: true }"
    (add)="openMemberDialog(UserOperation.Create)"
    #grid
  >
    <ng-template kendoGridToolbarTemplate>
      <div class="k-d-flex k-justify-content-end k-w-full">
        <button
          kendoGridAddCommand
          size="medium"
          themeColor="secondary"
          [disabled]="gridWrapperComponent.userOperation !== UserOperation.None"
        >
          <span class="custom-symbol user turquoise k-mr-3"></span>
          <span>Benutzer hinzufügen</span>
        </button>
      </div>
    </ng-template>

    <kendo-grid-checkbox-column
      [width]="40"
      [headerClass]="{ 'k-text-center': true }"
      class="list-selection-check"
      [resizable]="false"
      [columnMenu]="false"
      [showSelectAll]="true"
    >
    </kendo-grid-checkbox-column>

    <kendo-grid-column field="member_name" title="Name" [class]="'cell-with-avatar'">
      <ng-template kendoGridCellTemplate let-row>
        <div class="k-d-inline-flex k-align-items-center">
          <app-shive-avatar [user]="row.member"></app-shive-avatar>
          <div class="member-name k-ml-3">{{ row.member | memberName }}</div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="deduct_from_budget" title="Von Budget abziehen">
      <ng-template kendoGridCellTemplate let-row>
        {{ row.deductCostsFromBudget }}
      </ng-template>
    </kendo-grid-column>

    @if (showHourlyExpenditureRateFormField()) {
      <kendo-grid-column
        field="expenditure_value_per_member"
        [width]="10"
        [title]="expenditureValueColumnTitle"
        headerClass="expenditure-value-per-member"
        class="expenditure-value-per-member"
      >
        <ng-template kendoGridCellTemplate let-row>
          {{
            row.expenditureRateHistory[row.expenditureRateHistory.length - 1].rate | shiveCurrency
          }}
        </ng-template>
      </kendo-grid-column>
    }

    @if (showBudgetHoursPerMemberFormField()) {
      <kendo-grid-column
        field="hours_per_member"
        [title]="hoursPerMemberColumnTitle"
        headerClass="hours-per-member"
        class="hours-per-member"
      >
        <ng-template kendoGridCellTemplate let-row>
          <div class="k-d-flex">
            {{ row.budgetSeconds | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
          </div>
        </ng-template>
      </kendo-grid-column>
    }

    <kendo-grid-column [columnMenu]="false" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-context-menu-anchor
          [dataItem]="dataItem"
          [gridWrapperComponent]="gridWrapperComponent"
        />
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</app-shive-grid>
